export default __webpack_public_path__ + "5f329d9239d09bc8dff6858dfc18b699.svg";